import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useVendorTaxReports = (year = null) => {
  const currentYear = year || new Date().getFullYear();

  const { data, isLoading, error } = useQuery({
    queryKey: ['vendorTaxReports', currentYear],
    queryFn: async () => {
      const response = await api.get(`/vendor/tax-reports?year=${currentYear}`);
      return response.data;
    }
  });

  const reports = data?.data || {};

  // Helper function to safely format currency amounts
  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '0.00';
    return numAmount.toFixed(2);
  };

  // Generate year options for dropdown
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= currentYear - 5; i--) {
      years.push(i);
    }
    return years;
  };

  return {
    reports,
    isLoading,
    error,
    formatAmount,
    generateYearOptions
  };
};

